<template>
  <div class="steps-content">
    <el-form
      ref="form"
      :model="formData"
      :rules="oneStepRules"
      @submit.native.prevent
    >
      <el-row v-if="isAdminOrCeoRole" :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="client">
            <p style="margin-right: 10px">Заказчик:</p>
            <p v-if="formData.client">
              <b>{{ formData.client.short_name }}</b>
            </p>
            <el-button type="primary" @click="visible = true">
              {{ formData.client ? 'Изменить' : 'Выбрать' }} заказчика
            </el-button>
            <router-link to="/clients-settings">
              <el-link type="primary" class="add-new-client">
                Создать нового заказчика
              </el-link>
            </router-link>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <p>Тип заявки:</p>
          <el-radio-group v-model="formData.type_code" @change="setTypeCode">
            <el-radio-button
              v-for="type in typeCodes"
              :key="type.label"
              :label="type.label"
              :class="{ 'small-radio': type.sub }"
            >
              {{ type.title }}
              <span v-if="type.sub"><br />{{ type.sub }}</span>
            </el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row v-if="isAdminOrCeoRole" :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="org_performer_id">
            <p style="margin-right: 10px">Исполнитель:</p>
            <el-select
              v-model="formData['org_performer_id']"
              placeholder="Выберите исполнителя"
            >
              <el-option
                v-for="item in performers"
                :key="item.id"
                :label="item.short_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-switch
            v-if="canCreateTudatka"
            v-model="formData['is_tudatka']"
            active-color="#409eff"
            inactive-color="#cccccc"
            active-text="Тудатка для собственного транспорта"
            :active-value="1"
            :inactive-value="0"
            :disabled="edit"
            style="margin-top: 27px"
            @change="setTudatka"
          />
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <autocomplete-custom
            placeholder="Регион погрузки"
            :lib="autocompleteSettingsOne.regionLoad"
            name="regionLoad"
            :edit="getText(0)"
            @selected="setRegionLoad"
          >
            Регион погрузки
          </autocomplete-custom>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :error="checkKladr">
            <autocomplete-custom
              placeholder="Населенный пункт"
              :lib="autocompleteSettingsOne.kladrLoad"
              name="kladrLoad"
              :disabled="isRegionLoad"
              :relation="autocompleteSettingsOne.kladrLoad.params.regionId"
              :edit="getText(1)"
              @selected="setLoadKladr"
            >
              Населенный пункт погрузки
            </autocomplete-custom>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="load_start_date">
            <p>Дата начала погрузки</p>
            <el-date-picker
              id="start_loading"
              v-model="formData.load_start_date"
              type="date"
              placeholder="Выберите дату погрузки"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              :readonly="edit"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item v-show="!isTudatka" prop="cars_count">
            <p>Сколько грузим в день, авто</p>
            <el-input-number
              v-model="formData.cars_count"
              controls-position="right"
              :min="0"
              placeholder="Введите количество авто"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :xs="24" :sm="12" :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item v-show="!isTudatka" prop="is_trawl">
            <p>Грузим тралы</p>
            <el-select v-model="formData.is_trawl" placeholder="Выберите">
              <el-option
                v-for="item in boolItems"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item v-show="!isTudatka" prop="load_type_id">
            <p>Способ погрузки</p>
            <el-select v-model="formData.load_type_id" placeholder="Выберите">
              <el-option
                v-for="item in load_type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item v-show="!isTudatka" prop="lifting_capacity">
            <p>Грузоподъемность весов на погрузке, т</p>
            <el-input-number
              v-model="formData.lifting_capacity"
              controls-position="right"
              :min="0"
              placeholder="Введите значение в тоннах"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item v-show="!isTudatka" prop="distance_libra">
            <p>Расстояние до весов, км</p>
            <el-input-number
              v-model="formData.distance_libra"
              controls-position="right"
              :min="0"
              placeholder="Введите значение в километрах"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="bottom_buttons">
      <span />
      <el-button @click="setFormData(1)">Далее</el-button>
    </div>
    <client-field-modal
      v-if="isAdminOrCeoRole"
      :visible="visible"
      :client="formData.client"
      @set="onSetClient"
      @close="visible = false"
    />
  </div>
</template>

<script>
import {
  autocompleteSettingsOne,
  pickerOptions,
  typeCodes,
} from '@/datas/consts'
import { boolItems, oneStepRules, tudatkaParamsFormOne } from './constants'
import { checkAutocomplite } from '@/helpers/functions'
import { mapActions, mapGetters } from 'vuex'
import AutocompleteCustom from '@/components/Forms/AutocompleteCustom'
import ClientFieldModal from '../Modals/ClientFieldModal'

export default {
  name: 'One',
  components: { AutocompleteCustom, ClientFieldModal },
  props: {
    saved: {
      type: Object,
      default: () => undefined,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      formData: {
        org_performer_id: '',
        load_point: '',
        load_point_kladr_id: '',
        load_coords_lat: '',
        load_coords_lon: '',
        load_start_date: '',
        load_type_id: '',
        lifting_capacity: undefined,
        cars_count: undefined,
        is_trawl: '',
        client: null,
        distance_libra: undefined,
        type_code: 'delivery',
        is_tudatka: 0,
      },
      load_point_region: {},
      checkKladr: '',
      visible: false,
      updated: false,
      typeCodes,
      boolItems,
      oneStepRules,
      autocompleteSettingsOne,
      pickerOptions,
      tudatkaDefault: tudatkaParamsFormOne,
    }
  },
  computed: {
    ...mapGetters({
      getLib: 'libs/getLib',
      performers: 'organizations/getOrganizations',
    }),
    load_type() {
      return this.getLib('loadTypes')
    },
    isRegionLoad() {
      return !this.autocompleteSettingsOne.kladrLoad.params.regionId
    },
    isTudatka() {
      return this.formData.is_tudatka
    },
    canCreateTudatka() {
      return this.formData.type_code === 'delivery'
    },
  },
  watch: {
    saved: {
      immediate: true,
      handler(newVal) {
        this.setAutocomplete(newVal)
      },
    },
  },
  mounted() {
    if (!this.edit) {
      this.fetchOrganizations({ can_be_performer: 1 })
    }
  },
  methods: {
    ...mapActions('organizations', ['fetchOrganizations']),
    onSetClient(val = null) {
      this.formData.client = val
    },
    setAutocomplete(val) {
      this.autocompleteSettingsOne.kladrLoad.params.regionId = null
      this.formData = { ...this.formData, ...val }
      this.updated = false
    },
    getText(flag = 0) {
      const { load_point, load_point_kladr_id } = this.formData

      return checkAutocomplite(
        flag,
        load_point,
        load_point_kladr_id,
        this.updated,
      )
    },
    setRegionLoad(item) {
      this.autocompleteSettingsOne.kladrLoad.params.regionId = item.id
      this.load_point_region = item

      if (this.updated) {
        this.formData.load_point_kladr_id = ''
        this.formData.load_point = ''
        this.formData.load_coords_lat = ''
        this.formData.load_coords_lon = ''
      }
    },
    setLoadKladr(item) {
      this.formData.load_point_kladr_id = item.id
      this.formData.load_point = item.name
        ? this.load_point_region.name + ',' + item.name
        : ''
      this.formData.load_coords_lat = item.coords_lat
      this.formData.load_coords_lon = item.coords_lon
      this.checkKladr = ''

      if (!this.updated) {
        this.updated = true
      }
    },
    setFormData(step) {
      if (!this.formData.load_point_kladr_id) {
        this.checkKladr = 'Укажите пункт погрузки'
        this.$emit('invalid')
      } else {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.$emit('change_step', { data: this.formData, step })
          } else {
            this.$emit('invalid')
          }
        })
      }
    },
    setTudatka() {
      for (let key in this.tudatkaDefault) {
        this.formData[key] = this.isTudatka
          ? this.tudatkaDefault[key]
          : this.saved[key]
      }
    },
    setTypeCode() {
      // если тип - не перевозка, то сбрасываем тудатку и возвращаем дефолтные значения
      if (this.formData.type_code !== 'delivery') {
        this.formData.is_tudatka = 0
        for (let key in this.tudatkaDefault) {
          this.formData[key] = this.saved[key]
        }
      }
    },
  },
}
</script>
